import React from 'react'
import { GeneralLedger } from '../../../../helpers/models/Models';
import { useFormik } from 'formik';
import { putDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess } from '../../../../constants/Toast';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import DefaultSelectInputBox from '../../../../constants/DefaultSelectBox';
import { YesNoOptions } from '../../../../constants/Options';
import DialogBox from '../../../../constants/DialogBox';

interface GLedgerEditProps {
    dialogOpen: boolean;
    currentItem: GeneralLedger | null;
    setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleFormSuccess: ()=>void;
}
const GLedgerEditView: React.FC<GLedgerEditProps> = ({ dialogOpen, handleFormSuccess, currentItem, setDialogOpen }) => {
    const initialValues = {
        gl_name: currentItem?.gl_name || "",
        gl_name_nep: currentItem?.gl_name_nep || "",
        gl_type: currentItem?.gl_type || "",
        rpt_det_mode: currentItem?.rpt_det_mode === 1 ? "1" : "2",
        actual_glid: currentItem?.actual_glid || "",
        gl_status: currentItem?.gl_status === 1 ? "1" : "2",

    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: authorValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("gl_name", values.gl_name);
            formData.append("gl_name_nep", values.gl_name_nep);
            formData.append("gl_status", values.gl_status?.toString() === "2" ? "0" : "1");
            formData.append("rpt_det_mode", values.rpt_det_mode?.toString() === "2" ? "0" : "1");
            try {
                await putDataToTheServer(AppURL.AccountURL + "account/general/ledger/update/view/" + currentItem?.glid, formData).then((res) => {
                    if (res?.status === 200) {
                        ToastSuccess({ message: res?.message });
                        setDialogOpen(false)
                        handleFormSuccess();
                    }
                    action.resetForm();
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <DialogBox open={dialogOpen} headerName='General Ledger Edit' close={() => setDialogOpen(false)}>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='text'
                            label='General Ledger Name'
                            name='gl_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            error={errors.gl_name}
                            disabled={false}
                            value={values.gl_name}
                            placeholder='Enter GL Name'
                            required={true}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <NepaliInputBox
                            label="GL Name(Nepali)"
                            name='gl_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'gl_name_nep' })}
                            value={values.gl_name_nep}
                            error={errors.gl_name_nep}
                            handleBlur={handleBlur}
                            touched={touched.gl_name_nep}
                            placeholder='Enter GL Name(Nepali)'
                            required={true} />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <DefaultSelectInputBox
                            label="Report Details Show"
                            options={YesNoOptions}
                            name='rpt_det_mode'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            placeholder='Select status'
                            value={values.rpt_det_mode}
                            touched={touched.rpt_det_mode}
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <DefaultSelectInputBox
                            label="Active"
                            options={YesNoOptions}
                            name='gl_status'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            placeholder='Select GL Status'
                            value={values.gl_status}
                            touched={touched.gl_status}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={20}>
                            <Button btn_type='update' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </DialogBox>
    )
}

export default GLedgerEditView